import {observer} from 'mobx-react-lite'
import React, {useRef} from 'react'
import {Lang} from 'yougile-lang'
import {IconButton} from '@components/common/base/buttons'
import {TwFavoritesColumn} from '@components/my-tasks/tasks-list/columns/containers'
import {useTaskStore} from '@components/my-tasks/tasks-list/task-store'
import {useTasksListStore} from '@components/my-tasks/tasks-list/tasks-list-store'
import {useSyncEvent} from '@containers/hooks'
import {cn} from '@containers/html-utils'

export const TaskFavoritesColumn = observer(() => {
  const cachedStore = useRef<any>()
  const [state, store] = useTaskStore()
  const [, taskListStore] = useTasksListStore()
  const {sort} = taskListStore
  cachedStore.current = store

  const sortedByFavorites = sort && sort.columnId === 'favorites'

  useSyncEvent('profile', {filter: store?.taskHub?.companyId || []}, () => {
    store.syncTaskData()

    store.syncTaskData()
  })

  const onClickOnStar = (event: React.MouseEvent<HTMLDivElement>) => {
    store.makeTaskFavorite()

    if (sortedByFavorites) {
      taskListStore.syncTasks()
    }

    event.stopPropagation()
  }

  if (!state) {
    return null
  }

  return (
    <TwFavoritesColumn>
      <div className="h-24 flex items-center">
        <IconButton
          icon={state.starred ? 'IconStarFilled' : 'IconStar'}
          color="secondary"
          size="small"
          wrapperSize="big"
          className={cn(
            'ml-auto',
            'mr-8',
            state.starred && '!text-marker hover:!text-marker-l20'
          )}
          onClick={onClickOnStar}
          content={Lang.context.common.starHint}
        />
      </div>
    </TwFavoritesColumn>
  )
})
